import {
  GeneralObject,
  TMOQListResponse,
  TMOQListPayload,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';
import { createTokenHeader } from '../utils/functions/headers';

export const moqService = emptySplitApi
  .enhanceEndpoints({
    addTagTypes: ['MaxOQList'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getMOQDetails: builder.query<GeneralObject, string>({
        query: (moqId) => ({
          method: 'GET',
          url: `product-order-limits/${Number(moqId)}`,
        }),
      }),
      getAllMOQList: builder.query<
        { data: TMOQListResponse[]; totalCount: number },
        TMOQListPayload
      >({
        query: (params) => ({
          method: 'GET',
          url: `product-order-limits`,
          params,
        }),
        transformResponse: (
          data: TMOQListResponse[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['MaxOQList'],
      }),
      deleteMOQ: builder.mutation<GeneralObject, number>({
        query: (moqId) => ({
          method: 'DELETE',
          url: `product-order-limits/${moqId}`,
        }),
        invalidatesTags: ['MaxOQList'],
      }),
      addMaxOrderableQty: builder.mutation<
        GeneralObject,
        GeneralObject
      >({
        query: (data) => {
          return {
            url: 'product-order-limits',
            method: 'POST',
            data,
          };
        },
        invalidatesTags: ['MaxOQList'],
      }),
      updateMaxOrderableQty: builder.mutation<
        GeneralObject,
        GeneralObject
      >({
        query: (data) => {
          return {
            url: 'product-order-limits',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['MaxOQList'],
      }),
      maxOQImport: builder.mutation({
        query: (data) => ({
          url: `product-order-limits/import`,
          method: 'POST',
          data,
          headers: createTokenHeader(),
        }),
        invalidatesTags: ['MaxOQList'],
      }),
    }),
  });

export const {
  useGetMOQDetailsQuery,
  useGetAllMOQListQuery,
  useDeleteMOQMutation,
  useAddMaxOrderableQtyMutation,
  useUpdateMaxOrderableQtyMutation,
  useMaxOQImportMutation,
} = moqService;
